import { useEffect, useState } from "react";
import { getPublicSiteSettings, readPublicCache } from "@/lib/data";

let cache = readPublicCache("settings");
let inflight = null;
let listeners = [];

function load() {
  if (!inflight) {
    inflight = getPublicSiteSettings().then((data) => {
      cache = data;
      listeners.forEach((fn) => fn(data));
      return data;
    }).finally(() => { inflight = null; });
  }
  return inflight;
}

let fetchedThisSession = false;

export function useSettings() {
  const [settings, setSettings] = useState(cache);

  useEffect(() => {
    let mounted = true;
    const handler = (s) => mounted && setSettings(s);
    listeners.push(handler);
    if (!fetchedThisSession) {
      fetchedThisSession = true;
      load();
    }
    return () => {
      mounted = false;
      listeners = listeners.filter((l) => l !== handler);
    };
  }, []);

  return { settings, loading: false, refresh: load };
}
